import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import * as moment from 'moment'
import {
	ModalDismissReasons,
	NgbDate,
	NgbDateAdapter,
	NgbModal,
	NgbModalRef,
	NgbDateParserFormatter,
	NgbDatepickerI18n,
	NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap'

import { CustomAdapter, CustomDateParserFormatter, CustomDatepickerI18n, I18n } from 'src/app/utils/calendarioPT.util'

import { ProfileService } from './../../shared/profile.service'
import { LoginService } from 'src/app/shared/login.service'
import { NotificationService } from 'src/app/shared/notification.service'

import { RegistroAtividade } from 'src/app/models/registroAtividade.model'
import { TipoPerfil } from 'src/app/models/tipoPerfil.model'
import { TipoAtividade } from 'src/app/models/tipoAtividade.model'
import { Usuario } from 'src/app/models/usuario.model'

import { CalendarioService } from './calendario.service'

import { environment } from 'src/environments/environment'

const daySubs_1 = environment.daySubstract_1
const daySubs_2 = environment.daySubstract_2

@Component({
	selector: 'app-calendario',
	templateUrl: './calendario.component.html',
	styleUrls: ['./calendario.component.scss'],
	providers: [
		I18n,
		{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
		{ provide: NgbDateAdapter, useClass: CustomAdapter },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
	],
})
export class CalendarioComponent implements OnInit, OnDestroy {
	title = 'CALENDARIO'
	dynamicUrl = '/calendario'

	calendario: RegistroAtividade
	calendarios: Array<RegistroAtividade> = []
	selectedAnoReferencia: string
	selectedMesReferencia: string
	selectedTipoPerfil: string
	selectedAnoEdicao: string

	userName: string

	createCalendarForm: FormGroup
	updateCalendarForm: FormGroup
	deleteCalendarForm: FormGroup

	modalRef: NgbModalRef
	closeResult: string

	disablebutton: boolean = true
	markDisabled = (date: NgbDateStruct) => {
		const day = new Date(date.year, date.month - 1, date.day).getDay()
		return day === 0 || day === 6 // 0 = Domingo, 6 = Sábado
	}

	tiposPerfilFilter: string[] = [] //'Todos', 'Consignatária', 'Patrocinadora'
	anosReferenciaFilter: number[] = []
	calendariosFilter: Array<RegistroAtividade> = []

	tiposPerfil = [TipoPerfil.consignataria, TipoPerfil.patrocinadora]
	mesReferencia = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']

	mesNotificacao: string = ''
	infoMessage = { status: 0, message: '' }

	date = new Date()
	currentDay = this.date.getDate()
	currentMonth = this.date.getMonth() + 1
	currentYear = this.date.getFullYear()
	nextYear = this.currentYear + 1
	lastYear = this.currentYear - 1

	dezCurrentYear = `12/${this.currentYear}`
	janCurrentYear = `01/${this.currentYear}`
	fevCurrentYear = `02/${this.currentYear}`
	dezNextYear = `12/${this.nextYear}`
	janNextYear = `01/${this.nextYear}`
	fevNextYear = `02/${this.nextYear}`

	showWeekNumbers = false

	model2: string
	loginDisplay = false

	perfilTecnico = false
	perfilNormativo = false

	private subscriptions: Subscription[] = []

	constructor(
		private calendarioService: CalendarioService,
		private dateAdapter: NgbDateAdapter<string>,
		private modalService: NgbModal,
		private toastrService: ToastrService,
		private router: Router,
		private formBuilder: FormBuilder,
		private loginService: LoginService,
		private perfilService: ProfileService,
		private notificationService: NotificationService
	) {}

	ngOnInit(): void {
		this.getTipoPerfil()
		this.getAnoReferencia()
		this.getCalendarios(this.selectedAnoReferencia, this.selectedTipoPerfil)
		this.createForm()
		this.updateForm()
		this.deleteForm()

		this.subscriptions.push(
			this.loginService.user$.subscribe((account) => {
				this.loginDisplay = !!account
				if (account) {
					this.userName = account.name
					this.perfilService.verificarPerfis()
					this.carregarPerfis()
				}
			})
		)
	}

	carregarPerfis() {
		this.perfilNormativo = this.perfilService.getPerfilNormativo()
		this.perfilTecnico = this.perfilService.getPerfilTecnico()
	}

	today(comp: any): void {
		comp.toggle()
		comp.navigateTo({
			year: +this.selectedAnoReferencia,
			month: +this.selectedMesReferencia,
		})
	}

	adicionaZero(numero: number): string {
		return numero < 10 ? `0${numero}` : `${numero}`
	}

	getTipoPerfil(): void {
		this.tiposPerfilFilter = ['Todos', TipoPerfil.consignataria, TipoPerfil.patrocinadora]
		this.selectedTipoPerfil = 'Todos'
	}

	getAnoReferencia(): void {
		const startYear = this.currentYear
		const endYear = Number(this.nextYear)

		this.anosReferenciaFilter = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i)

		this.selectedAnoReferencia = this.selectedAnoEdicao ?? this.currentYear.toString()
	}

	getCalendarios(anoReferencia: string, tipoPerfil: string): void {
		this.infoMessage.status = 2

		this.calendarioService.getEnvioNotificacao(anoReferencia).subscribe((res) => {
			if (res.status <= 400) {
				this.notificationService.showMessage(res.status, res.statusText, 'read', this.dynamicUrl)
			} else {
				this.infoMessage.status = 3
				this.calendarios = this.completarCalendario(res.Documents, tipoPerfil)
				this.calendariosFilter = this.calendarios
			}
		})
	}

	completarCalendario(calendario: RegistroAtividade[], perfil: string): RegistroAtividade[] {
		const tiposPerfilFilterComplete: string[] = []
		const mesReferenciaNotificacao = this.mesReferencia.map((mes) => `${mes}/${this.selectedAnoReferencia}`)

		// Determina quais perfis devem ser incluídos
		switch (perfil) {
			case 'Todos':
				tiposPerfilFilterComplete.push(TipoPerfil.consignataria, TipoPerfil.patrocinadora)
				break
			case TipoPerfil.consignataria:
				tiposPerfilFilterComplete.push(TipoPerfil.consignataria)
				break
			case TipoPerfil.patrocinadora:
				tiposPerfilFilterComplete.push(TipoPerfil.patrocinadora)
				break
			default:
				return calendario // Se o perfil não corresponder a nenhum caso, retorna o calendário inalterado
		}

		// Filtra o calendário com base no perfil
		if (perfil !== 'Todos') {
			calendario = calendario.filter((item) => item.tipoPerfil === perfil)
		}

		// Completa o calendário para todos os meses e perfis necessários
		mesReferenciaNotificacao.forEach((mesString) => {
			tiposPerfilFilterComplete.forEach((itemPerfil) => {
				if (!calendario.some(({ mesReferenciaNotificacao, tipoPerfil }) => mesReferenciaNotificacao === mesString && tipoPerfil === itemPerfil)) {
					const objCalendario = new RegistroAtividade()
					objCalendario.mesReferenciaNotificacao = mesString
					objCalendario.tipoPerfil = itemPerfil

					calendario.push(objCalendario)
				}
			})
		})

		// Ordena o calendário por mês de referência
		calendario.sort((a, b) => a.mesReferenciaNotificacao!.localeCompare(b.mesReferenciaNotificacao!))

		return calendario
	}

	private atualizarFiltros(anoReferencia: string, tipoPerfil: string): void {
		this.selectedAnoReferencia = anoReferencia
		this.selectedTipoPerfil = tipoPerfil
		this.getCalendarios(this.selectedAnoReferencia, this.selectedTipoPerfil)
	}

	onChangeAnoReferencia(form: string): void {
		this.atualizarFiltros(form, this.selectedTipoPerfil)
	}

	onChangeTipoPerfil(form: string): void {
		this.atualizarFiltros(this.selectedAnoReferencia, form)
	}

	onChange(event, form) {
		if (event.target.value) form.tipo = event.target.value
	}

	rulesDisabledCreate(calendario) {
		if (calendario.dataNotificacao1) {
			return true
		}
		const dataAtual = new Date()
		const anoAtual = dataAtual.getFullYear()
		const mesAtual = this.adicionaZero(dataAtual.getMonth() + 1)
		const dataFormatadaAtual = new Date(`${anoAtual}-${mesAtual}-01`)

		const [mes, ano] = (calendario.mesReferenciaNotificacao || '').split('/').map(Number)
		const dataReferenciaNotificacaoDate = new Date(ano, mes - 1)

		return dataFormatadaAtual > dataReferenciaNotificacaoDate
	}

	rulesDisabledUpdate(calendario: { tipoPerfil?: string; dataNotificacao1?: string; mesNotificacao?: string }): boolean {
		const { tipoPerfil, dataNotificacao1, mesNotificacao } = calendario

		if (dataNotificacao1) {
			return false // Habilita o botão
		}
		// Desabilita o botão se o perfil for 'Patrocinadora'
		if (tipoPerfil === 'Patrocinadora' && !dataNotificacao1) {
			return true
		}

		// Desabilita o botão se o perfil for 'Consignatária' e dataNotificacao1 for nula
		if (tipoPerfil === 'Consignatária' && !dataNotificacao1) {
			return true
		}

		if (tipoPerfil === 'Consignatária' && dataNotificacao1 && mesNotificacao) {
			// Formata e compara a data de notificação
			const [dia, mes, ano] = (dataNotificacao1 + '/' + mesNotificacao).split('/').map(Number)
			const dataNotificacaoFormatada = new Date(ano, mes - 1, dia)
			const dataAtual = new Date()

			// Desabilita o botão se a data de notificação for menor ou igual à data atual
			return dataAtual >= dataNotificacaoFormatada
		}

		// Caso contrário, habilita o botão
		return false
	}

	rulesDisableDelete(calendario: { dataNotificacao1?: string; mesReferenciaNotificacao?: string }): boolean {
		// Obtém e formata a data atual
		const dataAtual = new Date()
		const dataFormatadaAtual = `${this.adicionaZero(dataAtual.getMonth() + 1)}/${dataAtual.getFullYear()}`

		// Obtém a data de referência da notificação
		const dataReferenciaNotificacao = calendario.mesReferenciaNotificacao || ''

		if (this.perfilTecnico && calendario.dataNotificacao1) {
			return false
		}

		// Compara as datas e verifica a condição de notificação
		return dataFormatadaAtual >= dataReferenciaNotificacao || !calendario.dataNotificacao1
	}

	subtractDays(qtdDaysRemove: number, dateToRemove: any): any {
		let date = moment(dateToRemove)
		const initialMonth = date.format('MM')

		while (qtdDaysRemove > 0) {
			date.subtract(1, 'day')

			if (date.day() !== 6 && date.day() !== 0) {
				qtdDaysRemove--
			}
		}

		if (initialMonth !== date.format('MM')) {
			return null // Ou outra lógica caso o mês mude
		}

		return date
	}

	calculateNotificationDays(form, dataSelecionada) {
		const { year, month, day } = dataSelecionada._model
		const data = moment(new Date(year, month - 1, day)) // Data selecionada
		const dataAtual = moment(new Date()) // Data atual
		const monthAtual = dataAtual.format('MM') // Mês atual
		const ultimoDiaDoMes = moment(data).endOf('month').date() // Último dia do mês selecionado

		// Verifica se o dia + daySubs_2 ultrapassa o mês atual
		if (form.value.tipoPerfil === TipoPerfil.patrocinadora) {
			if (monthAtual == `0${month}`.slice(-2)) {
				if (day + daySubs_2 > ultimoDiaDoMes) {
					this.notificationService.showMessage(
						200,
						`Esta data não pode ser cadastrada, pois o dia ${day - daySubs_2}, ${day - daySubs_1} não é mais permitido! `,
						'info',
						this.dynamicUrl
					)
					this.disablebutton = true
					return
				}
			}
		}

		let datas = '' // Variável para armazenar as datas calculadas

		// Verificação para perfis patrocinadora
		if (form.value.tipoPerfil === TipoPerfil.patrocinadora) {
			// Subtrair dias de forma segura usando moment
			let dataSubstract_1 = this.subtractDays(daySubs_1, data)
			let dataSubstract_2 = this.subtractDays(daySubs_2, data)

			// Verificação de datas inválidas
			if (!dataSubstract_1.isValid() || !dataSubstract_2.isValid()) {
				this.notificationService.showMessage(400, `A data calculada é inválida. Por favor, revise as entradas.`, 'create', this.dynamicUrl)
				this.disablebutton = true
				return
			}

			const today = moment().startOf('day').add(1, 'day') // Considera o próximo dia como referência mínima

			if (dataSubstract_1.isBefore(today) || dataSubstract_2.isBefore(today)) {
				this.notificationService.showMessage(200, `Data calculada, o dia limite deve ser no mínimo dia ${day + daySubs_2}!`, 'info', this.dynamicUrl)
				this.disablebutton = true
				return
			}

			// Inclua o dia selecionado junto com as outras datas e ordene em ordem decrescente
			datas = [data, dataSubstract_2, dataSubstract_1]
				.filter((dia) => dia.isValid()) // Filtra apenas datas válidas
				.sort((a, b) => a.diff(b)) // Ordena as datas em ordem decrescente
				.map((d) => d.format('DD')) // Formata as datas como DD
				.join(', ')
		} else if (form.value.tipoPerfil === TipoPerfil.consignataria) {
			// Para consignataria, o dia é o selecionado
			datas = moment(data).format('DD') // Formata a data final como DD
		}

		this.createCalendarForm.patchValue({
			datasEnvio: datas,
			mesNotificacao: `${('0' + month).slice(-2)}/${year}`,
		})

		this.updateCalendarForm.patchValue({
			dataNotificacao1: datas.split(',')[0]?.trim() || null,
			dataNotificacao2: datas.split(',')[1]?.trim() || null,
			dataNotificacao3: datas.split(',')[2]?.trim() || null,
			mesNotificacao: `${('0' + month).slice(-2)}/${year}`,
		})

		this.disablebutton = false
	}

	create(calendario: RegistroAtividade, form: any): void {
		const [mes, ano] = calendario.mesReferenciaNotificacao!.split('/').map(Number)
		this.selectedMesReferencia = mes.toString() // Converte o número para string

		// Converte a data selecionada para o modelo apropriado
		const initialDate = new NgbDate(ano, mes, 1)
		this.dateAdapter.toModel(initialDate)

		// Atualiza as datas desativadas e abre o modal
		this.openModal(form)

		// Atualiza o formulário com os dados do calendário
		this.createCalendarForm.patchValue({
			id: calendario.id,
			usuario: this.userName,
			mesReferenciaNotificacao: calendario.mesReferenciaNotificacao,
			mesNotificacao: calendario.mesNotificacao,
			tipoPerfil: calendario.tipoPerfil,
			diaLimite: calendario.dataNotificacao1,
			datasEnvio: [calendario.dataNotificacao1, calendario.dataNotificacao2, calendario.dataNotificacao3].filter(Boolean).join(' '),
		})
	}

	createForm(): void {
		this.createCalendarForm = this.formBuilder.group({
			id: [''],
			mesReferenciaNotificacao: [''],
			mesNotificacao: [''],
			usuario: [''],
			tipoPerfil: [''],
			diaLimite: ['', Validators.required],
			datasEnvio: [''],
		})
	}

	onCreate(): void {
		const formValues = this.createCalendarForm.value
		const diasEnvio = formValues.datasEnvio.split(',').map((d) => d.trim())

		// Cria um novo registro de atividade
		const registro: any = {
			tipo: TipoAtividade.envioNotificacao,
			dataHora: new Date(),
			usuario: this.userName,
			mesReferenciaNotificacao: formValues.mesReferenciaNotificacao,
			tipoPerfil: formValues.tipoPerfil,
			mesNotificacao: formValues.tipoPerfil === 'Consignatária' ? formValues.mesNotificacao.trim() : formValues.mesReferenciaNotificacao,
			dataNotificacao1: diasEnvio[0] || '',
			dataNotificacao2: diasEnvio[1] || '',
			dataNotificacao3: diasEnvio[2] || '',
		}

		//Envia o registro para o serviço
		this.calendarioService.createEnvioNotificacao(registro).subscribe(
			(res) => {
				this.notificationService.showMessage(res.status, 'Dias de envio notificação definido com sucesso.', 'create', this.dynamicUrl)
				this.closeAndRefresh()
			},
			(error) => this.notificationService.showMessage(error.status, error.message || 'Erro desconhecido', 'create', this.dynamicUrl)
		)

		// Atualiza o ano selecionado para edição
		this.selectedAnoEdicao = formValues.mesReferenciaNotificacao.slice(3, 7)
	}

	update(calendario: RegistroAtividade, form) {
		this.selectedMesReferencia = calendario.mesReferenciaNotificacao ? calendario.mesReferenciaNotificacao.split('/')[0] : ''

		const date = new NgbDate(Number(this.selectedAnoReferencia), Number(this.selectedMesReferencia), 1)

		this.dateAdapter.toModel(date)

		this.openModal(form)

		this.updateCalendarForm.patchValue({
			id: calendario.id,
			tipo: 'EnvioNotificacao',
			dataHora: new Date(),
			usuario: this.userName,
			mesReferenciaNotificacao: calendario.mesReferenciaNotificacao,
			mesNotificacao: calendario.mesNotificacao,
			tipoPerfil: calendario.tipoPerfil,
			diaLimite: calendario.dataNotificacao1,
      datasEnvio: [calendario.dataNotificacao1, calendario.dataNotificacao2, calendario.dataNotificacao3].filter(Boolean).join(', '),
		})
	}

	updateForm() {
		this.updateCalendarForm = this.formBuilder.group({
			id: [''],
			tipo: [''],
			dataHora: [''],
			usuario: [''],
			mesReferenciaNotificacao: [{ disabled: true }],
			mesNotificacao: [''],
			dataNotificacao1: [null],
			dataNotificacao2: [null],
			dataNotificacao3: [null],
			tipoPerfil: [''],
      datasEnvio: [''],
		})
	}

	onUpdate() {
		this.onChange(event, this.updateCalendarForm)
		const calendar = { ...this.updateCalendarForm.value }
    const diasEnvio = calendar.datasEnvio.split(',').map((d) => d.trim())

    const registro: any = {
			tipo: TipoAtividade.envioNotificacao,
			dataHora: new Date(),
			usuario: this.userName,
			mesReferenciaNotificacao: calendar.mesReferenciaNotificacao,
			tipoPerfil: calendar.tipoPerfil,
			mesNotificacao: calendar.tipoPerfil === 'Consignatária' ? calendar.mesNotificacao.trim() : calendar.mesReferenciaNotificacao,
			dataNotificacao1: diasEnvio[0] || '',
			dataNotificacao2: diasEnvio[1] || '',
			dataNotificacao3: diasEnvio[2] || '',
		}

		this.calendarioService.update(calendar).subscribe(
			(res) => {
				this.notificationService.showMessage(res.status, 'Registro atualizado com sucesso!', 'update', this.dynamicUrl)
				this.closeAndRefresh()
			},
			(error) => this.notificationService.showMessage(error.status, error || error.mensagem, 'update', this.dynamicUrl)
		)
	}

	private isSpecialMonth(mesReferencia: string): boolean {
		const specialMonths = [this.janCurrentYear, this.janNextYear, this.fevCurrentYear, this.fevNextYear, this.dezCurrentYear, this.dezNextYear]
		return specialMonths.includes(mesReferencia)
	}

	navigation(mesReferencia: string, tipoPerfil: string): string {
		if (tipoPerfil === 'Consignatária' && this.isSpecialMonth(mesReferencia)) {
			return 'arrow'
		}
		return 'none'
	}

	outsideDays(mesReferencia: string, tipoPerfil: string): string {
		if (tipoPerfil === 'Consignatária' && this.isSpecialMonth(mesReferencia)) {
			return 'visible'
		}
		return 'hidden'
	}

	verificationMonthCurrentYearMinDate(mesReferenciaNotificacao, mesReferenciaCalendar) {
		const dezCurrentYear = `12/${this.currentYear}`
		const janCurrentYear = `01/${this.currentYear}`
		const fevCurrentYear = `02/${this.currentYear}`

		switch (mesReferenciaNotificacao) {
			case dezCurrentYear:
				return {
					year: this.currentYear,
					month: 11,
					day: 1,
				}

			case janCurrentYear:
				return {
					year: this.lastYear,
					month: 12,
					day: 1,
				}

			case fevCurrentYear:
				return {
					year: this.currentYear,
					month: 1,
					day: 1,
				}

			default:
				return {
					year: this.currentYear,
					month: mesReferenciaCalendar,
					day: 1,
				}
		}
	}

	verificationMonthNextYearMinDate(mesReferenciaNotificacao, mesReferenciaCalendar) {
		const dezNextYear = `12/${this.nextYear}`
		const janNextYear = `01/${this.nextYear}`
		const fevNextYear = `02/${this.nextYear}`

		switch (mesReferenciaNotificacao) {
			case dezNextYear:
				return {
					year: this.nextYear,
					month: 11,
					day: 1,
				}

			case janNextYear:
				return {
					year: this.currentYear,
					month: 12,
					day: 1,
				}

			case fevNextYear:
				return {
					year: this.nextYear,
					month: 1,
					day: 1,
				}

			default:
				return {
					year: this.nextYear,
					month: mesReferenciaCalendar,
					day: 1,
				}
		}
	}

	verificationMonthCurrentYearMaxDate(mesReferencia) {
		const janCurrentYear = `01/${this.currentYear}`
		const fevCurrentYear = `02/${this.currentYear}`
		const dezCurrentYear = `12/${this.currentYear}`

		switch (mesReferencia) {
			case janCurrentYear:
				return {
					year: this.currentYear,
					month: 1,
					day: 31,
				}
			case fevCurrentYear:
				return {
					year: this.currentYear,
					month: 2,
					day: 28,
				}
			case dezCurrentYear:
				return {
					year: this.currentYear,
					month: 12,
					day: 31,
				}
			default:
				return {
					year: this.currentYear,
					month: 12,
					day: 31,
				}
		}
	}

	verificationMonthNextYearMaxDate(mesReferencia) {
		const janNextYear = `01/${this.nextYear}`
		const fevNextYear = `02/${this.nextYear}`
		const dezNextYear = `12/${this.nextYear}`

		switch (mesReferencia) {
			case janNextYear:
				return {
					year: this.nextYear,
					month: 1,
					day: 31,
				}

			case fevNextYear:
				return {
					year: this.nextYear,
					month: 2,
					day: 28,
				}

			case dezNextYear:
				return {
					year: this.nextYear,
					month: 12,
					day: 31,
				}

			default:
				return {
					year: this.nextYear,
					month: 12,
					day: 31,
				}
		}
	}

	minDate(mesReferencia, tipoPerfil) {
		var mes = mesReferencia.split('/')[0]

		const mesReferenciaCalendar = mes % 10 === 0 ? mes / 10 : mes

		const mesVerificacao = `${this.adicionaZero(this.currentMonth)}/${this.currentYear}`

		if (parseInt(this.selectedAnoReferencia) === this.currentYear) {
			if (mesReferencia == mesVerificacao) {
				return {
					year: this.currentYear,
					month: this.currentMonth,
					day: this.currentDay + 1,
				}
			} else {
				if (tipoPerfil == 'Consignatária') {
					return this.verificationMonthCurrentYearMinDate(mesReferencia, mesReferenciaCalendar)
				} else {
					return {
						year: this.currentYear,
						month: mesReferenciaCalendar,
						day: 1,
					}
				}
			}
		} else if (parseInt(this.selectedAnoReferencia) === this.nextYear) {
			if (tipoPerfil == 'Consignatária') {
				return this.verificationMonthNextYearMinDate(mesReferencia, mesReferenciaCalendar)
			} else {
				return {
					year: this.nextYear,
					month: mesReferenciaCalendar,
					day: 1,
				}
			}
		} else {
			return {
				year: this.currentYear,
				month: 1,
				day: 1,
			}
		}
	}

	maxDate(mesReferencia) {
		if (parseInt(this.selectedAnoReferencia) === this.currentYear) {
			return this.verificationMonthCurrentYearMaxDate(mesReferencia)
		} else if (parseInt(this.selectedAnoReferencia) === this.nextYear) {
			return this.verificationMonthNextYearMaxDate(mesReferencia)
		} else {
			return {
				year: this.currentYear,
				month: 12,
				day: 31,
			}
		}
	}

	delete(calendario, form) {
		this.openModal(form)
		this.deleteCalendarForm.patchValue({
			id: calendario.id,
			tipo: 'EnvioNotificacao',
			dataHora: calendario.dataHora,
			mesReferenciaNotificacao: calendario.mesReferenciaNotificacao,
			tipoPerfil: calendario.tipoPerfil,
			dataNotificacao1: calendario.dataNotificacao1,
			mesNotificacao: calendario.mesNotificacao,
		})
		this.calendario = calendario
	}

	deleteForm() {
		this.deleteCalendarForm = this.formBuilder.group({
			id: [{ value: '', disabled: true }],
			mesReferenciaNotificacao: [{ value: '', disabled: true }],
			mesNotificacao: [{ value: '', disabled: true }],
			tipoPerfil: [{ value: '', disabled: true }],
			diaLimite: [{ value: '', disabled: true }],
			datasEnvio: [{ value: '', disabled: true }],
		})
	}

	onDelete(form) {
		this.calendario = JSON.parse(JSON.stringify(form.value))
		this.calendarioService.delete(this.calendario).subscribe(
			(res: any) => {
				this.notificationService.showMessage(res.status, "Registro deletado com sucesso!", 'delete', this.dynamicUrl)
				this.closeAndRefresh()
			},
			(error) => this.notificationService.showMessage(error.status, error || error.messsage, 'delete', this.dynamicUrl)
		)
	}

	openModal(form) {
		this.disablebutton = true

		this.modalRef = this.modalService.open(form)
		this.modalRef.result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`
			}
		)
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'Pressione ESC para sair'
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'Click OK para executar a tarefa'
		} else {
			return `with: ${reason}`
		}
	}

	handleError(msg: any) {
		this.toastrService.error(`${msg} - Ocorreu um erro ao fazer a chamada, por favor tente mais tarde!`, 'PTA - Portal de Transferência de Arquivos')
		this.closeAndRefresh()
	}

	private closeAndRefresh() {
		this.modalRef.close()
		this.router.navigateByUrl('/calendario')
		this.getTipoPerfil()
		this.getAnoReferencia()
		this.getCalendarios(this.selectedAnoReferencia, this.selectedTipoPerfil)
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe())
	}
}
